// extracted by mini-css-extract-plugin
export default {"container":"Container_container__1Dghw","minHeight":"Container_minHeight__ditVV","start":"Container_start__R+et1","column":"Container_column__ZUXrl"};